<span class="form-label-marker">{{ labelMarkerText }}</span>
